/** @format */

import {Switch as SwitchUI} from '@headlessui/react'
import clsx from 'clsx'
import React, {ReactElement, ReactNode} from 'react'

import {UpgradeLink} from '@src/components/tailwind/UpgradeLink'

type SwitchProps = {
  title: ReactNode
  description?: ReactNode
  checked: boolean
  onChange: (checked: boolean, fieldName?: string) => void
  className?: string
  titleClass?: string
  disabled?: boolean
  fieldName?: string
  upgrade?: ReactElement<typeof UpgradeLink> | null
}

export default function Switch(props: SwitchProps) {
  const {description, disabled, fieldName, onChange, upgrade} = props

  const isDisabled = disabled || !!upgrade
  const handleChange = (checked: boolean) => {
    onChange(checked, fieldName)
  }
  return (
    <SwitchUI.Group as="div" className="my-4 flex justify-between">
      <div className="flex flex-col">
        <SwitchUI.Label
          as="p"
          className={clsx('font-bold text-gray-900', props.titleClass)}
          passive
        >
          {props.title}
        </SwitchUI.Label>

        {description || upgrade ? (
          <SwitchUI.Description as="div" className="mt-2 text-sm text-gray-500">
            {description && <span>{description}</span>}
            {upgrade && (
              // keep a space between the upgrade link and the description
              <> {upgrade}</>
            )}
          </SwitchUI.Description>
        ) : null}
      </div>
      <SwitchUI
        checked={props.checked}
        onChange={handleChange}
        className={clsx(
          'focus:ring-light-blue-500 relative ml-4 inline-flex h-6 w-11 shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2',
          isDisabled ? 'cursor-default' : 'cursor-pointer',
          props.checked ? 'bg-secondary' : 'bg-gray-200',
          props.className,
        )}
        disabled={isDisabled}
      >
        <span className="sr-only">Use setting</span>
        <span
          aria-hidden="true"
          className={clsx(
            isDisabled && 'translate-x-2.5',
            !isDisabled && props.checked ? 'translate-x-5' : 'translate-x-0',
            'inline-block h-5 w-5 rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
          )}
        />
      </SwitchUI>
    </SwitchUI.Group>
  )
}
